// extracted by mini-css-extract-plugin
module.exports = {"background":"quote-module--background--FNyh0","quote":"quote-module--quote--2-oW3","section":"quote-module--section--2UPr-","wrapper":"quote-module--wrapper--3L8am"};